import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Flex,
  Stack,
  Grid,
  GridItem,
  IconButton,
  Icon,
  Box,
} from "@chakra-ui/react";
import {
  textPrimary,
  textSecondary,
  newBorder,
  backgroundLight,
  primaryAlt,
  white,
} from "../../utils/colors";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import useIsMobile from "../../hooks/useIsMobile";
import { FaXmark } from "react-icons/fa6";

const ConfirmApprovePublicModal = ({
  isOpen,
  onClose,
  confirmAction,
  treatmentPlanDetails,
}) => {
  const { t } = useTranslation();

  const isMobile = useIsMobile();
  // console.log("treatmentPlanDetails", treatmentPlanDetails);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered={isMobile ? false : true}
    >
      <ModalOverlay />
      <ModalContent
        borderRadius={{ base: "0", md: "1.5rem" }}
        w={{ base: "100%", md: "600px" }}
        minH={{ base: "100%", md: "auto" }}
        maxW="100vw"
        m={0}
        border={`1px solid ${newBorder}`}
      >
        <ModalHeader
          w="100%"
          color={textPrimary}
          maxW={["100%", "100%", "100%"]}
          m="0 auto"
          fontSize={["1rem", "1rem", "1.125rem"]}
          p={["1rem 1.5rem", "1rem 1.5rem 1.5rem"]}
          borderBottom={`1px solid ${newBorder}`}
          fontWeight="500"
        >
          <Flex w="100%" align="center" justify="space-between">
            <Text>
              {t("common.approveTreatmentPlanConfirmationTitlePublic")}
            </Text>

            <IconButton
              size="sm"
              bg={backgroundLight}
              color={textSecondary}
              onClick={onClose}
              borderRadius="10rem"
              _hover={{ bg: primaryAlt, color: white }}
            >
              <Icon as={FaXmark} />
            </IconButton>
          </Flex>
        </ModalHeader>

        <ModalBody
          p="0rem 0rem 0"
          color={textSecondary}
          fontWeight="500"
          fontSize="1rem"
        >
          <Box
            w="100%"
            p="1.5rem 1.5rem 2rem"
            borderBottom={`1px solid ${newBorder}`}
          >
            <Flex
              w="100%"
              align="center"
              justify="center"
              m="1rem 0 1rem"
              direction="column"
            >
              <Text
                fontSize="1.25rem"
                color={textPrimary}
                fontWeight="500"
                textAlign="center"
              >
                {t("treatmentPlan.treatmentPlan")} -{" "}
                <Text as="span">{treatmentPlanDetails?.treatmentPlanID}</Text>
              </Text>

              <Flex
                align="center"
                justify="center"
                direction="column"
                m="0.5rem 0 0"
              >
                <Flex align="center">
                  <Text
                    fontSize="sm"
                    color={textSecondary}
                    fontWeight="500"
                    textAlign="center"
                    mr={1}
                  >
                    {t("treatmentPlan.createdAt")}:
                  </Text>
                  <Text
                    fontSize="sm"
                    color={textSecondary}
                    fontWeight="500"
                    textAlign="center"
                  >
                    {treatmentPlanDetails &&
                      dayjs(treatmentPlanDetails.createdAt).format(
                        "YYYY-MM-DD"
                      )}
                  </Text>
                </Flex>
                <Flex align="center">
                  <Text
                    fontSize="sm"
                    color={textSecondary}
                    fontWeight="500"
                    textAlign="center"
                    mr={1}
                  >
                    {t("treatmentPlan.treatmentPlanPrice")}:
                  </Text>
                  <Text
                    fontSize="sm"
                    color={textSecondary}
                    fontWeight="500"
                    textAlign="center"
                  >
                    {treatmentPlanDetails && treatmentPlanDetails.totalPrice} €
                  </Text>
                </Flex>
              </Flex>
            </Flex>

            <Flex p={["0.5rem 0rem 2rem", "0rem 1.5rem 1rem"]}>
              <Stack gap={1} w="100%" p="1rem 0 0">
                <Text
                  fontSize="1.125rem"
                  color={textPrimary}
                  fontWeight="500"
                  textAlign={["left", "center"]}
                >
                  {t("common.approveTreatmentPlanConfirmationTextPublic")}
                </Text>

                <Text
                  fontSize="sm"
                  color={textSecondary}
                  fontWeight="500"
                  p={["1rem 0rem 0", "0.25rem 2rem 0"]}
                  textAlign={["left", "center"]}
                >
                  {t(
                    "common.approveTreatmentPlanConfirmationTextDescriptionPublic"
                  )}
                </Text>
              </Stack>
            </Flex>

            {/* <Flex
              p={["0.5rem 0rem 2rem", "1rem 2.5rem 2rem", "0rem 1.5rem 1rem"]}
            >
              <Stack gap={1} w="100%" p="0rem 0">
                <Text fontSize="md" color={textPrimary} fontWeight="500" mt={4}>
                  {t("common.approveTreatmentPlanConfirmationTextPublicFull")}
                </Text>

              </Stack>
            </Flex> */}
          </Box>
          <Flex
            w="100%"
            justifyContent="center"
            alignItems="center"
            p={["1.5rem 1.5rem ", "1.5rem 0 "]}
            gap="1rem"
          >
            <Button
              bg={backgroundLight}
              color={textSecondary}
              size="lg"
              fontSize="sm"
              borderRadius="10rem"
              onClick={onClose}
              w={["50%", "auto"]}
            >
              {t("button.close")}
            </Button>

            <Button
              colorScheme="green"
              size="lg"
              fontSize="sm"
              borderRadius="10rem"
              onClick={confirmAction}
              w={["50%", "auto"]}
            >
              {t("treatmentPlan.approvePlan")}
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmApprovePublicModal;
